import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

const MobileFilters = ({ children }) => {
  const [collapseOpen, collapseSetOpen] = useState(true);

  const handleCollapseClick = () => {
    collapseSetOpen(!collapseOpen);
  };

  return (
    <Box sx={{ backgroundColor: 'surface.mobile' }}>
      <Collapse in={collapseOpen} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
      <Button onClick={handleCollapseClick} variant="text">
        {collapseOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
        {collapseOpen ? 'Collapse Filters' : 'Expand Filters'}
      </Button>
    </Box>
  );
};

MobileFilters.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MobileFilters;
